import { createContext, useEffect } from "react";
import get from "lodash/get";
import orderBy from "lodash/orderBy";
import { useSelector } from "react-redux";

import { getDispensaryPromotions } from "api/requests/getDispensaryPromotions";
import usePromiseReducer from "hooks/usePromiseReducer";
import { getCurrentDispensary } from "redux/selectors/dispensary";

type PromotionsContext = {
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: fix me please, do not replicate
  dispatch?: any;
  error?: boolean | null;
  fetching?: boolean;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: fix me please, do not replicate
  selectors: any;
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: fix me please, do not replicate
  state?: any;
};

const initialState: PromotionsContext = {
  error: null,
  fetching: false,
  selectors: {
    hasPromos: null,
    results: null,
  },
};

const Context = createContext(initialState);

const { Provider } = Context;

const ACTION_TYPES = {
  ERROR: "ERROR",
  FETCH: "FETCH",
};

const usePromotionReducer = (state = {}) => {
  return usePromiseReducer(
    // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: fix me please, do not replicate
    (state: any, action: any) => {
      switch (action.type) {
        case ACTION_TYPES.FETCH:
          return { ...state, ...action.payload, error: null };
        case ACTION_TYPES.ERROR:
          return { ...state, ...action.payload, fetching: false };
        default:
          return state;
      }
    },
    { ...initialState, ...state }
  );
};

const fetchAction = (
  isFetching: boolean,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: fix me please, do not replicate
  data: any[] | null,
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: fix me please, do not replicate
  dispatch: any
) => {
  const state = {
    payload: { data, fetching: isFetching },
    type: ACTION_TYPES.FETCH,
  };
  if (data) {
    state.payload.data = data;
  }
  dispatch(state);
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: fix me please, do not replicate
const errorAction = (error: any, dispatch: any) => {
  dispatch({ payload: { error }, type: ACTION_TYPES.ERROR });
};

const getPromotionsAction = (
  dispensaryId: number,
  dispatch = () => {}
  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: fix me please, do not replicate
): Promise<any> => {
  fetchAction(true, null, dispatch);

  return getDispensaryPromotions(dispensaryId)
    .then((response) => {
      const payload = orderBy(response, ["orderNumber"], "asc");

      fetchAction(false, payload, dispatch);
      return payload;
    })
    .catch((e) => {
      errorAction(e.message || "An unknown error ocurred", dispatch);
      return Promise.reject(e);
    });
};

// eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: fix me please, do not replicate
const PromotionProvider = ({ children, initialState }: any) => {
  const { id, slug } = useSelector(getCurrentDispensary) || {};

  // eslint-disable-next-line @typescript-eslint/no-explicit-any -- TODO: fix me please, do not replicate
  const [state, dispatch]: any = usePromotionReducer(initialState);

  useEffect(() => {
    if (
      !initialState &&
      !state.fetching &&
      !state.error &&
      id &&
      !get(state, "data")
    ) {
      getPromotionsAction(id, dispatch);
    }
  }, [initialState, state, slug, dispatch, id]);

  const results = get(state, "data") || [];

  return (
    <Provider
      value={{
        dispatch: {
          getPromotions: () => getPromotionsAction(slug, dispatch),
        },
        selectors: {
          hasPromos: results.length > 0,
          results,
        },
        state,
      }}
    >
      {children}
    </Provider>
  );
};

export { Context as default, getPromotionsAction, PromotionProvider };
